import React, { Component } from 'react';
import { Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { find, get } from 'lodash';
import { Link } from 'react-router-dom';
import ComparisonDetails from './Details';
import sample from './sample.json';
import IncomeChart from '../../components/pages/comparison/IncomeChart';




class ComparisonList extends Component {
	constructor(props) {
		super(props);
		const months = 3;
		const entities = sample.slice(0,2).map(e=>this.formatEntity(e, months))
		
		this.state = {
			months,
			entities
		};
		
	}
	
	addAnother = () => {
		let { entities, months } = this.state;
		const newEntity = this.formatEntity(sample[entities.length], months);
		this.setState({
			entities: [...entities, newEntity]
		})
	}
	
	formatEntity = (entity, months) => {
		const { isrc, track_title, release_date } = entity;
		const dateStart = moment(release_date).endOf('month');
		const dateEnd = dateStart.clone().add(months, 'months').endOf('month');
		
		
		return {
			id: isrc,
			entity: 'tracks',
			title: track_title,
			dateStart: dateStart.format('YYYY-MM-DD'),
			dateEnd: dateEnd.format('YYYY-MM-DD')		
		}
	}


	componentDidMount(){
	}
	


	componentWillUnmount() {
	}
	
	componentDidUpdate(prevProps) {
	}

	
	render() {
		const { entities = [] } = this.state;
		return <div className="wrapper wrapper-content light-blue-bg">
			<div className="todo">
				<button type="button" onClick={this.addAnother}>Add Entity</button>
				
			</div>
			<div className="todo">
				<IncomeChart entities={entities} />
			</div>
			<div className="comparison-wrapper">
				{entities.map(entity=><ComparisonDetails key={entity.id} entity={entity} />)}
			</div>
		</div>

	}
	
}

function mapStateToProps(state) {
	return {
	}
}


export default withRouter(connect(mapStateToProps)(ComparisonList));